import React from "react";
import { useParams } from "react-router-dom";
import {
  CCard,
  CCardBody,
  CRow,
  CCol,
  CImage,
  CBadge,
  CButton,
  CBreadcrumb,
  CBreadcrumbItem,
} from "@coreui/react";
import { Link } from "react-router-dom";

const employees = [
  {
    id: 1,
    name: "Nguyễn Mai Phương (Tracy)",
    code: "0TLHCM002",
    phone: "0790139700",
    email: "trinh.baseinc@gmail.com",
    dob: "20/11/1987",
    gender: "Nữ",
    startDate: "31/07/2018",
    officialDate: "02/02/2021",
    position: "Trưởng phòng Marketing",
    status: "Active",
    contract: "HĐ Lao động 1 năm",
    workLocation: "Chi nhánh HCM",
    workSchedule: "Lịch VP",
    specialization: "Operation",
    maritalStatus: "Đã kết hôn",
    employeeType: "Full-Time Employee",
    img: "/images/nhanvien1.png",
    seniority: "4 năm 6 tháng 23 ngày",
  },
];

const ChiTietNhanSu = () => {
  const { id } = useParams();
  const employee = employees.find((e) => e.id === Number(id));

  if (!employee) return <p>Không tìm thấy nhân sự!</p>;

  return (
    <CRow className="p-3">
      <CBreadcrumb className="mb-3">
        <CBreadcrumbItem>
          <Link to="/ds_nhansu">Nhân sự</Link>
        </CBreadcrumbItem>
        <CBreadcrumbItem active>Xem chi tiết </CBreadcrumbItem>
      </CBreadcrumb>

      <div className="d-flex justify-content-end gap-2 mb-3">
        <Link to={`/edit/${employee.id}`}>
          <CButton color="info" variant="outline" size="lg">
            Sửa thông tin
          </CButton>
        </Link>
        <Link to={`/xem_lich`}>
          <CButton color="warning" variant="outline" size="lg">
            Xem lịch làm việc
          </CButton>
        </Link>
        <Link to={`/BangLuong/${employee.id}`}>
          <CButton color="primary" variant="outline" size="lg">
            Xem lương dự kiến
          </CButton>
        </Link>
      </div>
      {employees.map((employee) => (
        <CCol key={employee.id} md={4}>
          <CCard className="text-center p-3 d-flex flex-column align-items-center">
            <CImage rounded src={employee.img} width="120px" className="mb-3" />
            <h5>{employee.name}</h5>
            <p className="text-muted">{employee.position}</p>
            <CBadge color="success">{employee.status}</CBadge>
            <p className="mt-2">❤️ {employee.seniority} làm việc</p>
            <p>
              <strong>{employee.code}</strong>
            </p>
            <p>
              <strong>{employee.position}</strong>
            </p>
            <p>{employee.email}</p>
            <p>{employee.phone}</p>
          </CCard>
        </CCol>
      ))}

      <CCol md={8}>
        <CCard className="p-3">
          <CCardBody>
            <h4>Thông tin chính</h4>
            <CRow>
              <CCol md={6}>
                <p>
                  <strong>Mã nhân sự:</strong> {employee.code}
                </p>
              </CCol>
              <CCol md={6}>
                <p>
                  <strong>Ngày bắt đầu:</strong> {employee.startDate}
                </p>
              </CCol>
            </CRow>
            <CRow>
              <CCol md={6}>
                <p>
                  <strong>Ngày chính thức:</strong> {employee.officialDate}
                </p>
              </CCol>
              <CCol md={6}>
                <p>
                  <strong>Số điện thoại:</strong> {employee.phone}
                </p>
              </CCol>
            </CRow>
            <CRow>
              <CCol md={6}>
                <p>
                  <strong>Hợp đồng:</strong> {employee.contract}
                </p>
              </CCol>
              <CCol md={6}>
                <p>
                  <strong>Email:</strong> {employee.email}
                </p>
              </CCol>
            </CRow>
            <CRow>
              <CCol md={6}>
                <p>
                  <strong>Giới tính:</strong> {employee.gender}
                </p>
              </CCol>
              <CCol md={6}>
                <p>
                  <strong>Ngày sinh:</strong> {employee.dob}
                </p>
              </CCol>
            </CRow>
            <CRow>
              <CCol md={6}>
                <p>
                  <strong>Văn phòng:</strong> {employee.workLocation}
                </p>
              </CCol>
              <CCol md={6}>
                <p>
                  <strong>Lịch làm việc:</strong> {employee.workSchedule}
                </p>
              </CCol>
            </CRow>
            <CRow>
              <CCol md={6}>
                <p>
                  <strong>Khu vực / Chuyên môn:</strong>{" "}
                  {employee.specialization}
                </p>
              </CCol>
              <CCol md={6}>
                <p>
                  <strong>Phân loại nhân sự:</strong> {employee.employeeType}
                </p>
              </CCol>
            </CRow>
            <p>
              <strong>Tình trạng hôn nhân:</strong> {employee.maritalStatus}
            </p>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default ChiTietNhanSu;
